module.exports = __webpack_public_path__ + "assets/img/h2.10c47499.jpg";